<template>
  <div class="ai-search">
    <div class="ai-search-wrap">
      <div class="title-wrap">
        <span class="title">AI作图</span>
        &nbsp;
        <span class="tips">Beta</span>
      </div>
      <div class="subtitle-wrap">
        <div class="subtitle-item"><span class="icon">1</span>口述提设计需求</div>
        <div class="subtitle-item"><span class="icon">2</span>作品可分图层编辑</div>
      </div>
      <div class="search-wrap">
        <ai-design-search-box v-model="keyword" :loading="searchLoading" @on-click="handleSearch">
          <div class="tags-wrap">
            <div class="tag-item active">banner</div>
            <div class="tag-item">海报(即将支持)</div>
          </div>
        </ai-design-search-box>
      </div>
    </div>
  </div>
</template>
<script>
import AiDesignSearchBox from '@/views/components/ai-design-search/index.vue'
import aigcService from '@/request/service/aigc-service'
export default {
  name: 'ai-design-search',
  components: {
    AiDesignSearchBox
  },
  data () {
    return {
      keyword: '',
      searchLoading: false
    }
  },
  methods: {
    handleSearch (val) {
      if (val) {
        this.searchLoading = true
        aigcService.generateWork({
          message: val
        }).then(d => {
          this.$router.push({
            name: 'work-free-editor',
            params: {
              id: d
            }
          })
        }).finally(() => {
          this.searchLoading = false
        })
      }
      console.log('handleSearch', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.ai-search {
  width: 100%;
  height: 100%;
  text-align: center;
  .ai-search-wrap {
    margin-top: 180px;
  }
  .title-wrap {
    text-align: center;
    .title {
      font-family: PingFangSC-Medium;
      background-image: linear-gradient(to right, rgba(28, 217, 179, 0.8), rgba(15, 66, 232, 0.8));
      -webkit-background-clip: text;
      font-size: 40px;
      font-weight: 600;
      color: transparent;
      backdrop-filter: blur(6px);
    }
    .tips {
      display: inline-block;
      color: #FDFDFD;
      background: #2BC2A4;
      border-radius: 2px;
      font-size: 12px;
      padding: 1px 4px;
    }
  }
  .subtitle-wrap {
    margin: 24px 0;
    font-size: 14px;
    color: #5C6370;
    text-align: center;
    .subtitle-item {
      margin: 0 24px;
      font-weight: 500;
      display: inline-block;
      .icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 8px;
        text-align: center;
        line-height: 20px;
        font-weight: 500;
        font-size: 12px;
        color: #5C6370;
        background: #F3F4F5;
        border-radius: 50%;
      }
    }
  }
  .search-wrap {
    display: inline-flex;
    width: 596px;
    .tags-wrap {
      margin-top: 16px;
      text-align: left;
      .tag-item {
        display: inline-block;
        padding: 3px 12px;
        margin-right: 16px;
        color: #898A8E;
        font-size: 14px;
        line-height: 1.5;
        border-radius: 4px;
        border: 1px solid #E0E0E0;
        &.active {
          color: #555C6A;
          background: #F2F2F2;
          border: 1px solid #E0E0E0;
        }
      }
    }
  }
}
</style>
